import api from '@/api/api';

const state = {
    testRuns: [],
    mtrNames: [],
};

const getters = {
    testRuns: state => state.testRuns,
    mtrNames: state => state.mtrNames,
};

const mutations = {
    SET_TEST_RUNS(state, testRuns) {
        state.testRuns = testRuns;
    },
    SET_MTR_NAMES(state, mtrNames) {
        state.mtrNames = mtrNames;
    },
};

const actions = {
    /**
     * Fetch all test runs and save it to state.
     * @return {Promise} result.
     */
    async fetchTestRuns({ commit }, { filters }) {
        try {
            const {
                test_runs, test_cases, test_cases_count,
                test_results, target_builds, target_builds_count
            } = await api.testRuns.fetchAll({ filters });
            commit('SET_TEST_RUNS', test_runs);
            commit('TestCases/SET_TEST_CASES', test_cases, { root: true });
            commit('TestCases/SET_TEST_CASES_TOTAL_COUNT', test_cases_count, { root: true });
            commit('TestResults/SET_TEST_RESULTS', test_results, { root: true });
            commit('TargetBuilds/SET_TEST_RUNS_TARGET_BUILDS', target_builds, { root: true });
            commit('TargetBuilds/SET_TEST_RUNS_TARGET_BUILDS_TOTAL_COUNT', target_builds_count, { root: true });
        } catch (error) {
            return Promise.reject('Error of test runs list fetching');
        }
    },
    /**
     * Fetch all mtr params and save it to state.
     * @return {Promise} result.
     */
    async fetchMtrNames({ commit, getters }) {
        if (getters.mtrNames.length > 0) return;
        try {
            const mtr_names = await api.targetBuilds.fetchMtrNames();
            commit('SET_MTR_NAMES', mtr_names);
        } catch (error) {
            return Promise.reject('Error of mtr list fetching');
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
